import React from "react";
import { BodyAsFormData } from "../../../services/utilities/util";
import md5 from "md5";
import { Link } from "react-router-dom";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class OccupierDetails extends React.Component {
  static contextType = FilterContext;

  constructor(props) {
    super(props);
  }

  state = {
    occupierDetails: {},
    filters: "",
  };

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post("api/edge/office/get_tenant_details", BodyAsFormData(filters))
      .then((res) => {
        console.log(res);
        this.setState({ occupierDetails: res.data });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_tenant_details",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({ occupierDetails: res.data });
        });
    }
  }

  render() {
    return (
      <div class="widget widgetDeveloper widgetWithExtraPadding borderRadiusClass p-0">
        <div class="row m-0 logoWithDetailsDesign">
          <div class="col-lg-5 p-0 logoWithDetailsDesignL">
            <img
              alt="Current Coverage Icon"
              src={this.state.occupierDetails.image}
              class="imgWidth100"
            />
          </div>
          <div class="col-lg-7 logoWithDetailsDesignR">
            <div className="logoWithDetailsDesignRInner">
              <h6>{this.state.occupierDetails.year_founded}</h6>
              <p>Year Founded</p>
            </div>
            <div className="logoWithDetailsDesignRInner">
              <h6>{this.state.occupierDetails.headquarters}</h6>
              <p>Head quarters</p>
            </div>
            <div className="logoWithDetailsDesignRInner">
              <h6 title={this.state.occupierDetails.website}>
                {this.state.occupierDetails.website}
              </h6>
              <p>Website</p>
            </div>
            <div className="logoWithDetailsDesignRInner">
              <h6>
                <a
                  target="_blank"
                  href={`https://www.linkedin.com/search/results/all/?keywords=${this.state.occupierDetails.leasing_rep}`}
                >
                  {this.state.occupierDetails.leasing_rep}
                </a>
              </h6>
              <p>Leasing Rep</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(OccupierDetails);
